import LookupText from '../../Elements/LookupText';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import React from 'react';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import urlHelper from '../../Helpers/urlHelper';
import moneyHelper from '../../Helpers/moneyHelper';

export default class CreditMemoItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.CreditMemoId = item.creditMemoId;
    this.CurrencyCode = item.currencyCode;
    this.ClientName = item.clientName;
    this.OfficeName = item.officeName;
    this.CreditMemoNumber = item.creditMemoNumber;
    this.Reason = item.reason;
    this.Description = item.description;
    this.InternalReferenceNumber =
      item.internalReferenceNumber === null || item.internalReferenceNumber === '' ? ' ' : item.internalReferenceNumber;
    this.FeeCredit = item.feeCredit;
    this.CurrencySymbol = item.currencySymbol;
    this.LineItemCount = item.lineItemCount;
    this.Status = item.status;
    this.FinalizedOn = item.finalizedOn;
    this.FinalizedOnFormatted = dateTimeHelper.toYYYYsMMsDDsHHsMM(this.FinalizedOn, '-');
    this.CreditMemoRequestId = item.creditMemoRequestId === null ? ' ' : item.creditMemoRequestId;
    this.ClientInvoiceNumber = item.clientInvoiceNumber;
    this.ClientInvoiceStatusCode = item.clientInvoiceStatusCode;
    this.ClientInvoiceId = item.clientInvoiceId;
    this.LineItemCredit = item.lineItemCredit;
    this.ClientInvoiceYrmo = item.clientInvoiceYrmo;
  }

  static NameOfTheIdField() {
    return 'CreditMemoNumber';
  }
  static nameOfTheItemDetailList() {
    return 'Credit Memo';
  }
  static MoneyFields = ['FeeCredit'];
  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }
  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'BARE #', name: 'CreditMemoNumber', className: 'text-left' },
        { label: 'Internal Reference Number', name: 'InternalReferenceNumber', className: 'text-left' },
        { label: 'Status', name: 'Status', className: 'text-left' },
        { label: 'Reason', name: 'Reason', className: 'text-left' },
        { label: 'Finalized On', name: 'FinalizedOnFormatted', className: 'text-left' },
        { label: 'Credit Memo Request ID', name: 'CreditMemoRequestId', className: 'text-left' },
        { label: 'Invoice #', name: 'ClientInvoiceId', className: 'text-left' },
        {
          label: 'Client Invoice Status',
          name: (item) => (
            <LookupText
              lookupId={43}
              value={item.ClientInvoiceStatusCode}
            />
          ),
          className: 'text-left',
        },
        { name: '', label: '' },
        { label: '# Items Credited', name: 'LineItemCount', className: 'text-left' },
        {
          label: 'Credit Amount',
          name: (item) => moneyHelper.toMoneyFormat(item.LineItemCredit, item.CurrencyCode),
          className: 'text-left',
        },
        {
          label: 'YRMO',
          name: 'ClientInvoiceYrmo',
          className: 'text-left',
        },
        {
          label: 'Description',
          name: 'Description',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Client Name', orderById: 'ClientName', data: 'ClientName' },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName' },
      { label: 'BARE #', orderById: 'CreditMemoNumber', data: CreditMemoItem.GetDetailCellContent, minWidth: 70 },
      {
        label: 'Credit',
        orderById: 'FeeCredit',
        data: (item) => {
          return moneyHelper.toMoneyFormat(item.LineItemCredit, item.CurrencyCode);
        },
      },
      { label: '# Items Credited', orderById: 'LineItemCount', data: 'LineItemCount', minWidth: 110 },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Reason', orderById: 'Reason', data: 'Reason' },
      { label: 'YRMO', orderById: 'ClientInvoiceYrmo', data: 'ClientInvoiceYrmo' },
      {
        label: 'Description',
        orderById: 'Description',
        data: (item) => (item.Description.length > 76 ? `${item.Description.substring(0, 76)} ...` : item.Description),
      },
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.CreditMemoNumber,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'creditmemodetails',
      `id=${item.CreditMemoId}`,
      'Open up in a new tab'
    );
  }
}
